module.exports = __webpack_public_path__ + "img/title.e726da4c.png";